import styled, { css } from 'styled-components';
import { Heading, Avatar } from '@bechtel/gds';

export const HeadingStyled = styled(Heading).attrs({
  size: '400',
  color: 'grey.1000',
})`
  padding-top: ${({ theme }) => theme.spacings[100]};
  padding-bottom: ${({ theme }) => theme.spacings[100]};
  white-space: nowrap;
`;

export interface AvatarRegularStyledProps {
  hasImageUrl: boolean;
}

export const AvatarRegularStyled = styled(Avatar)<AvatarRegularStyledProps>`
  border-width: 1px !important;
  ${({ theme, hasImageUrl }) => css`
    border-color: ${theme.colors.white};
    background-color: ${hasImageUrl ? theme.colors.white : theme.colors.grey[200]};
  `}
`;
